import axios from 'axios';
import { Dictionary, WorkflowQueueDataModel } from '@/types';

const WorkflowQueueApiUrl = 'workflowqueue/';

export const WorkflowQueueService = {
  async getWorkflowQueueAsync(id: number, filters?: Dictionary<string>): Promise<WorkflowQueueDataModel> {
    const response = await axios.get(WorkflowQueueApiUrl.concat(id.toString()), {
      params: { serializedFilters: filters }
    });
    return response.data;
  }
};
